/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.join.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Datetime from "vux/src/components/datetime/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
export default {
  name: 'DatetimeRange',
  props: {
    value: {
      type: String
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD HH:mm'
    },
    name: {
      type: String
    },
    required: {
      type: [Boolean, Number],
      default: false
    },
    labelWidth: {
      type: Number,
      default: 9.6
    }
  },
  components: {
    Group: Group,
    Datetime: Datetime,
    Cell: Cell
  },
  computed: {
    formatValueLeft: {
      get: function get() {
        return this.value ? this.value.split(',')[0] : '';
      },
      set: function set(v) {
        this.$emit('input', [v, this.formatValueRigth].join(','));
      }
    },
    formatValueRigth: {
      get: function get() {
        return this.value ? this.value.split(',')[1] : '';
      },
      set: function set(v) {
        this.$emit('input', [this.formatValueLeft, v].join(','));
      }
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {}
};